import React, { Component } from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import debounce from 'lodash-es/debounce';
import isEqual from 'lodash-es/isEqual';
import { Api } from '../utils/api';
import Grid from '@material-ui/core/Grid';
import TablePagination from '@material-ui/core/TablePagination';
import EntitiesListTable from './components/entities_list_table.component';
import { PaymentFilterForm } from './forms/payment-filter.form';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Typography from '@material-ui/core/Typography';
import Button from "@material-ui/core/Button/Button";
import CircularProgress from '@material-ui/core/CircularProgress';
import { observer } from 'mobx-react';
import ToolsButton from '../components/tools_button.component';

const rowsPerPage = 30;

const EntitiesList = observer(

  class EntitiesList extends Component {

    constructor() {
      super();
      this.api = new Api();
      this.search = debounce(this.searchInitial.bind(this), 250, { leading: true });
      this.onChange = this.onChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
      this.advancedChange = this.advancedChange.bind(this);
      this.toggleAdvancedFilter = this.toggleAdvancedFilter.bind(this);
    }

    oldValues = null;

    componentDidMount() {
      this.search();
    }

    /** 
     * Search bar 
     */

    searchInitial() {
      const { query, searchValues, page } = this.props.store;
      const params = { search: query, ...searchValues };
      this.api.get('/entities', { ...params, page:page+1,rows:rowsPerPage })
      .then(({ data : { entities, count } }) => {
        this.props.store.setCount(count);
        this.props.store.setEntities(entities);
      });
    }

    handleChangePage(event ,page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      this.search();
    }

    toggleAdvancedFilter() {
      this.props.store.toggleAdvancedFilter();
      this.search();
    }

    advancedChange(query) {
      this.props.store.setSearchValues(query);
      this.search();
    }

    /** 
     * Other search components
     */

    handleChange(values) {
      this.findEntities({
        ...values
      });
    }

    findEntities(searchValues, force=false) {
      if (isEqual(searchValues, this.oldValues || {}) && !force) {
        return;
      }
      this.oldValues = searchValues;
      const { page } = this.props.store;

      this.api.get('/entities', {
        ...searchValues,
        page
      })
      .then(({ data : { entities, count } }) => {
        this.props.store.setEntities(entities);
        this.props.store.setCount(count);
      });
    }

    /**
     * 
     */

    render() {
      const { entities } = this.props.store;

      return entities ? 
          this.renderList() : 
          (
              <div>
                  <CircularProgress color="primary" />
              </div>
          );
    }

    renderList(){ 
      
      const { entities, count, page } = this.props.store;

      return (
        <>
        <div className="new-icon">
          <ToolsButton context_type="EntityNotesList" context_id="me" showNavigation showOnlyNotes/>
        </div>
          <Row>
            <Col xs={1}/>
            <Col md={8}>
              <Form style={{ width: '100%'}}>
                <Form.Control type="text" placeholder="Search Here" onChange={this.onChange}/>
              </Form>
            </Col>
            <Col md={2}>
                <Typography variant="body2">
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.toggleAdvancedFilter.bind(this)}>
                    <FontAwesomeIcon icon="filter" className="filter"/>
                      Filtro Avançado
                  </Button>
                </Typography>
              </Col>
          </Row>
          {this.props.store.advancedFilter && (
            <Row>
                <Col xs={1}/>
                <Col md={6}>
                  <PaymentFilterForm  searchValues={this.props.store.searchValues} onChange={this.advancedChange}>
                  </PaymentFilterForm>
                </Col>
            </Row>
          )}
          
          <EntitiesListTable
            entities={entities}
          />

          <Grid container >
            <Grid item md={12} >
              <TablePagination className="pagination"
                rowsPerPageOptions={[]}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
              />
            </Grid>
            
          </Grid>
        </>
      );
    }
  }
);

export default EntitiesList;
